import React, { useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import typography from "../../cssUtils/typography";
import VoiceLogsTable from "./VoiceLogsTable";

const VoiceLogs = (props) => {
  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: 20,
    serverSidePage: 0,
  });
  const [lastSynced, setLastSynced] = useState(null);

  return (
    <Box sx={{ px: 0, width: "100%" }}>
      <Grid container alignItems="center" sx={{ mb: 2 }}>
        <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end" }}>
          {lastSynced && (
            <Typography sx={{ ...typography.bodyLarge }} color="text.secondary">
              Last call received: {lastSynced} <i>(Logs may take up to 2 minutes to sync)</i>
            </Typography>
          )}
        </Grid>
      </Grid>

      <VoiceLogsTable
        key={props.refreshKey}
        refreshKey={props.refreshKey}
        controller={controller}
        setController={setController}
        setLastSynced={setLastSynced}
      />
    </Box>
  );
};

export default VoiceLogs;
